import { allowedTypes as allowedTypesDragAndDrop } from '@components/drag-and-drop/src/drag-and-drop.type';
import { allowedTypes as allowedTypesInputFile } from '@components/input-file/src/input-file.types';

export const isFileFormatCorrect = ({
  type,
  allowedTypes,
}: {
  type: string;
  allowedTypes?: (typeof allowedTypesDragAndDrop | typeof allowedTypesInputFile)[number][] | [];
}): boolean => {
  if (!allowedTypes) return true;
  const types = allowedTypes.join('|');
  const regex = new RegExp(types);
  return regex.test(type);
};
